import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-batch',
  templateUrl: './edit-batch.component.html',
  styleUrls: ['./edit-batch.component.scss']
})
export class EditBatchComponent implements OnInit {
  batchId:any
  batchDate:any
  batchData={
    name:'',
    description:'',
    start_date:'',
    start_time: '',
    end_time:'',
    days: '',
    specailnotes: '',
    instructor: [{_id:''}],
    joining_link: '', 
    max_student: '',
    notes: '',
    admin_notes: '',
    course_id:{_id:''},
    learning_mode:{_id:''},
    student_overview: {description:''},
    activity: {description:''},
    rating: {description:''},
    placement: {description:''},
    tesimonial: {description:''},
    certification: {description:''},

  }
  // selectValue='';
  selectedValue=null;
  // course_id:'';
  // course_id:{_id:''}
  courselist:[]
  learningMode=null
  learningList=[];
 learningId= "631ad8abce5c666542591bd9"
 currentUrl:any

 alert_list=[
  {id:'yes', name:'Yes'},
  {id:'no', name:'No'},
]
alert_event:any
usersList = []
selected_user =null
  constructor(private activatedroute:ActivatedRoute,
    public toastr: ToastrService,
    private route:Router,public apiService:ApiService) {
    this.currentUrl=this.activatedroute.snapshot.routeConfig.path
    this.activatedroute.paramMap.subscribe(params => { 
      this.batchId = params.get('id'); 
      console.log(this.currentUrl)
   })
  }
  ngOnInit(): void {
    this.alert_event='no'
    
    if(this.currentUrl== 'edit-batch/:id'){
      this.getBatchById()
      this.getCourseList()
      this.getLearningTagBycategory()
      this.getUsers()
    }
    if(this.currentUrl== 'edit-batch-audit/:id'){
      this.getBatchById()
    }
    
  }
  getUsers() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.usersList = res.items
    })
  }
  getSelectUserId(event: any) {
    this.selected_user
  }
  getCourseList(){
    this.apiService.getCourseList(1,100).subscribe((res:any)=>{
       this.courselist= res.data.items
    })
  }
  getCourseById(event){
    this.selectedValue

  }
  getLearningTagBycategory(){
    this.apiService.getTagByTagCatgoryId(this.learningId).subscribe((res:any)=>{
      this.learningList=res.data
    })
   }
   getLearningId(event:any){
    this.learningMode
   }
  getBatchById(){
    this.apiService.getBatchById(this.batchId).subscribe((res:any)=>{
      this.batchData=res.data
        if(this.batchData.course_id !==null){
          this.selectedValue=this.batchData.course_id._id
        }
        if(this.batchData.learning_mode !==null){
          this.learningMode=this.batchData.learning_mode._id
        }
        if(this.batchData.instructor !==null){
          this.selected_user = this.batchData.instructor[0]?._id
        }
    })
  }
  updateBatch(){
    if(this.batchId){
      this.batchData.course_id=this.selectedValue
      this.batchData.learning_mode=this.learningMode
      this.batchData.instructor = this.selected_user
      if(this.currentUrl== 'edit-batch/:id'){
        this.apiService.updateBatch(this.batchId,this.batchData).subscribe((res:any)=>{
          if(res.statusCode === 200){
             this.toastr.success('Updated Successfully')
              this.route.navigate(['/batches/batch-list'])
          }
          else{this.toastr.error(res.error)}  
        })
      }
      if(this.currentUrl== 'edit-batch-audit/:id'){
        this.apiService.updateBatch(this.batchId,this.batchData).subscribe((res:any)=>{
          if(res.statusCode === 200){
             this.toastr.success('Updated Successfully')
              this.route.navigate(['/batches/batch-audit'])
          }
          else{this.toastr.error(res.error)}  
        })
      }

   
    }
    else{
      alert('Something went Wrong!!!')
    }

  }
  back(){
    this.route.navigate(['/batches/batch-list'])

  }
  selectAlert(event){
    this.alert_event
  }
}
